import { CheckedState } from '@radix-ui/react-checkbox';
import { ColumnDef } from '@tanstack/react-table';

import { Checkbox } from '../core/Checkbox';
import { Actions } from './action-column/actions';

export const columns: (
    t: (key: string) => string,
    items: any,
    columns: any,
    selectedRows: any[],
    areAllRowsSelected: boolean,
    allItemsSelected: boolean,
    handleSelectAll: (checked: CheckedState)=> void,
    _handleSelectedItems: (item: any)=> void,
    isCatalogTable: boolean,
    redirectToItemDetail?: (item:any) => void,
    showEditor?: (row: any, primaryKey__?:string, editorState?: { onShowItemDetails: true }, items?:any) => void,
    deleteItem?: (row: any) => void,
    showItemReview?: (item: any) => void,
) => ColumnDef<any>[] = (t,
    items,
    columns,
    selectedRows,
    areAllRowsSelected,
    allItemsSelected,
    handleSelectAll,
    _handleSelectedItems,
    isCatalogTable = false,
    redirectToItemDetail,
    showEditor,
    deleteItem,
    showItemReview) => [
    {
        accessorKey: 'select',
        enableSorting: false,
        meta: {
            leftPinned: true,
            draggable: false,
        },
        // LAX-10056: in "select all" mode the header + row checkboxes are disabled;
        // individual (de)selection is not allowed - leaving the mode clears everything.
        header: () => (
            <Checkbox
                className='tw-mt-[5px]'
                id="select-all"
                isChecked={areAllRowsSelected}
                disabled={allItemsSelected}
                onCheckedChange={(checked)=> {
                    handleSelectAll(checked);
                }}
            />
        ),
        size: 50,
        enableResizing: false,
        cell: (row: any) => {
            return <Checkbox
                className='tw-mt-[5px]'
                isChecked={allItemsSelected || selectedRows.find((primaryKey: string)=> primaryKey === row.row.original.primaryKey__) !== undefined}
                disabled={allItemsSelected}
                onCheckedChange={() => _handleSelectedItems(row.row.original)}
            />;
        },
        getCellProps: () => ({
            className: 'tw-sticky tw-left-0 tw-bg-white tw-z-10',
        }),
    },
    ...columns,
    {
        accessorKey: 'actions',
        header: t('ACTIONS'),
        meta: {
            pinned: true,
        },
        size: isCatalogTable? 130 : 295,
        enableResizing: false,
        cell: (row: any) => {
            {
                return <Actions
                    row={row}
                    isCatalogTable={isCatalogTable}
                    redirectToItemDetail={redirectToItemDetail}
                    showEditor={showEditor}
                    deleteItem={deleteItem}
                    showItemReview={showItemReview}
                    items={items}/>;
            }
        },
    },
];
